import styled from 'styled-components';

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: ${({ theme }) => theme.spacing(6)};
  min-height: 32rem;
  height: 100%;
`;

export const Container = styled.div``;

export const List = styled.ul`
  margin: 0;
  padding: 0;
  width: 100%;

  list-style: none;
`;

export const ListItem = styled.li`
  min-width: 0;
`;
